import {Component, Input, Output, EventEmitter} from '@angular/core';

// idle = wait for start | saving = the process to save | saved = the real save is OK
// error = We got an error, we can retry | failed = Its failed completly, and we do not want to retry again
export type DraftSaveStatus = 'idle' | 'saving' | 'saved' | 'error' | 'failed';

@Component({
    selector: 'app-phonenumber-save-draft-card',
    templateUrl: './phonenumber-save-draft-card.component.html',
    standalone: false
})
export class PhonenumberSaveDraftCardComponent {

  @Input() enabled: boolean = true;
  @Input() status: DraftSaveStatus = 'idle';
  @Output() saveDraft = new EventEmitter<void>();
  @Output() close = new EventEmitter<void>();

  onCloseDraft() {
    this.close.emit();
  }

  onSaveDraft() {
    this.saveDraft.emit();
  }
}
